// extracted by mini-css-extract-plugin
module.exports = {"body":"Modal_body__26oK8","close":"Modal_close__3_fBT","title":"Modal_title__Nmo6r"};